<script setup lang="ts">
interface BurgerProps {
  open?: boolean
}

const props = withDefaults(defineProps<BurgerProps>(), { open: false })
</script>

<template>
  <button
    :aria-label="open ? $t('open') : $t('close')"
    class="burger"
    :class="{ 'is-open': props.open }"
  >
    <span class="patty" />
    <span class="patty" />
    <span class="patty" />
  </button>
</template>

<style scoped>
.burger {
  --burger-offset: calc(var(--spacing) * 1.5);

  display: flex;
  flex-direction: column;
  gap: calc(var(--spacing) * 1.5);
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;

  cursor: pointer;
}

.patty {
  display: flex;
  background: currentColor;
  height: 1.5px;
  width: 30px;
  position: relative;
  transition:
    transform 300ms var(--ease-custom-circ),
    opacity 300ms var(--ease-custom-circ);
  transform-origin: center;
}

.is-open .patty:nth-child(1) {
  transform: translate3d(0, calc(var(--burger-offset) + 1.5px), 0) rotate(45deg);
}

.is-open .patty:nth-child(2) {
  opacity: 0;
}

.is-open .patty:nth-child(3) {
  transform: translate3d(0, calc((var(--burger-offset) + 1.5px) * -1), 0) rotate(-45deg);
}
</style>
